import React, { useState, useEffect } from 'react';
import { Grid, Dialog } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { apiBaseUrl, getAccessToken } from '../../api/client';

export default function ShowAttachments(props) {
  const [contentUrl, setContentUrl] = useState();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(
      `${apiBaseUrl()}/requests/${props.servicerequestid}/attachments/${props.attachmentid}`,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    )
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load attachment');
        return response.blob();
      })
      .then((blob) => {
        setLoading(false);
        setContentUrl(URL.createObjectURL(blob));
      })
      .catch((err) => {
        alert(`ERR: ${err.message || err}`);
      });
  }, [props.servicerequestid, props.attachmentid]);
  return (
    <Grid>
      <Dialog open={props.open} onClose={props.close}>
        {loading ? (
          <Grid
            container
            justify="center"
            alignItems="center"
            style={{ height: '800px', width: '600px' }}
          >
            <CircularProgress />
          </Grid>
        ) : (
          <object
            style={{ height: '800px', width: '600px' }}
            data={contentUrl}
            type={props.type}
          />
        )}
      </Dialog>
    </Grid>
  );
}
